import { useEffect, useState, useContext } from 'react';
import AuthContext from "contexte/AuthContext"
import { useTranslation } from 'react-i18next';
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import Notification from 'components/notifications/Notification';
import { launchError } from 'components/notifications';
import DownloaderLink from 'components/DownloaderLink/DownloaderLink';
import './sumsubManuallyAccepted.css'
import { downloadSumsubReport, fetchAvailableSumsubReport } from 'services/complianceReportsServices';

const SumsubManuallyAcceptedReports = () => {

  const { user } = useContext(AuthContext);
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);
  const type = 'sumsub-manually-accepted'

  useEffect(() => {
    const fetchReportList = async () => {
      try {
        const data = await fetchAvailableSumsubReport({ user, type })
        setFiles(data);
      } catch (error) {
        launchError(t('notifications.reports.compliance.list.error'))
      }
    }

    fetchReportList();
  }, [])

  return (
    <DashboardLayout page={t("pages_name.report_compliance_sumsub_manually_accepted")}>
      <Notification />
      <div className='sumsub_manually_accepted_titleComponent'>
        <h2>{t("pages.report_compliance_sumsub_manually_accepted.title")}</h2>
      </div>
      <div>
        <ul>
          {files.map(file => (
            <DownloaderLink
              filename={`sumsub_manually_acccepted_${file}.xlsx`}
              fetchData={downloadSumsubReport}
              fetchDataParams={{ user, fileName: file, type }}
              type={'excel'}
              display={file}
              key={file}
            />
          ))}
        </ul>
      </div>
    </DashboardLayout>
  )
}

export default SumsubManuallyAcceptedReports;